// JsFromRoutes CacheKey 76b7204809ae4adb47e7af5bbedc2e7c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/storage/blobs/redirect/:signed_id/*filename'),
  showGet: /* #__PURE__ */ definePathHelper('get', '/storage/blobs/:signed_id/*filename'),
}
